import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface LoginPayload {
  email: string;
  senha: string;
}

export interface ApiResponse {
  token: string;
  mensagem: string[];
}

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  //private apiUrl = 'https://localhost:7103/api/autenticacao/Login';
  private baseUrl = environment.apiUrlExbeOn;
  private endpoint = '/autenticacao/Login';

  constructor(private http: HttpClient) { }

  Login(usuarioData: LoginPayload): Observable<ApiResponse> {
    //return this.http.post<ApiResponse>(this.apiUrl, usuarioData);
    return this.http.post<ApiResponse>(`${this.baseUrl}${this.endpoint}`, usuarioData);
  }

  
}